import SimpleBanner from "../components/landing/SimpleBanner";
import AdditionalTerms from "../components/landing/AdditionalTerms";

const AdditionalTermsForPartners = () => {
    return (
        <>
            <SimpleBanner title="Additional Terms for Partners" />
            <AdditionalTerms />
        </>
    );
};

export default AdditionalTermsForPartners;
